import { BrowserRouter, Routes, Route } from "react-router-dom";
import CheckoutPage from "./pages/CheckoutPage";
import HomePage from "./pages/HomePage";
import RootLayout from "./layout";
import ThankYouPage from "./pages/ThankYouPage";
import NotFoundPage from "./pages/NotFoundPage";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./hooks";
import { shopSliceActions } from "./store/slices/shopSlice";
import { getShopState } from "./store";
import ProductPage from "./pages/ProductPage";
import LoadingSpinner from "./components/layouts/common/Loading";
function App() {
  const { shopInfo, isReady } = useAppSelector(getShopState);
  const dispatch = useAppDispatch();
  // Phải gọi ở đây (không phải RootLayout) vì RootLayout chỉ render sau khi isReady = true
  useEffect(() => {
    dispatch(shopSliceActions.getDataShop());
  }, [dispatch]);
  // Chưa biết shop có chuyển sang tên miền riêng không thì chưa render giao diện
  if (!isReady && !shopInfo.is_not_found) return <LoadingSpinner />
  if (shopInfo.is_not_found) return <NotFoundPage />
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<RootLayout />} >
          <Route path="/" element={<HomePage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/checkout/thank-you" element={<ThankYouPage />} />
          <Route path="/product/:slug" element={<ProductPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
